import { formatCurrency } from '../utils';

const elements = Array.from(document.querySelectorAll('.js-update-cart'));

elements.forEach(form => form.addEventListener('click', handleChange));

function handleChange(event) {
	updateCart(event.currentTarget)
		.then(response => response.json())
		.then(json => updateUI(json))
		.catch(error => console.log(error));
}

function updateCart(form) {
	const inputs = form.elements;
	const url = inputs['action'].value;

	const options = {
		method: 'post',
		body: new FormData(form),
		headers: {
			Accept: 'application/json',
			'X-Requested-With': 'XMLHttpRequest',
			'Cache-Control': 'no-store',
		},
	};

	return fetch(url, options);
}

function updateUI(json) {
	console.log(json);
	const { cart } = json;
	const errorContainer = document.querySelector('.js-cart-errors');
	const minValueNotice = document.querySelector('.js-min-value-notice');
	const checkoutSubmitButton = document.querySelector('.js-checkout-submit-button');
	// const spinButton = document.querySelector('.js-spin-input');
	// const ariaValue = spinButton.getAttribute('aria-valuenow');
	// let value = spinButton.value;
	// value = ariaValue;

	// console.log(value);

	if (errorContainer) {
		errorContainer.hidden = true;
		errorContainer.innerHTML = '';
	}

	if (minValueNotice) {
		let total = cart.itemSubtotal;
		let minTotal = minValueNotice.dataset.minItemSubtotal;

		if (total < minTotal) {
			minValueNotice.removeAttribute('hidden');
			checkoutSubmitButton.setAttribute('disabled', '');
		} else {
			minValueNotice.setAttribute('hidden', '');
			checkoutSubmitButton.removeAttribute('disabled');
		}
	}

	if (json.errors && errorContainer) {
		errorContainer.hidden = false;

		Object.values(json.errors).forEach(errors => errors.forEach(message => addError(message)));

		function addError(message) {
			const li = document.createElement('li');
			li.textContent = message;
			errorContainer.append(li);
		}

		errorContainer.scrollIntoView({
			block: 'end',
			inline: 'nearest',
		});
	}

	[
		'totalTax',
		'totalPrice',
		'itemSubtotal',
		'totalDiscount',
		'totalShippingCost',
	].forEach(price => updatePrice(price));

	function updatePrice(prop) {
		const props = Array.from(document.querySelectorAll(`[data-cart="${prop}"]`));
		props.forEach(el => el.textContent = formatCurrency(cart[prop]));
	}

	const subTotalElements = Array.from(document.querySelectorAll('[data-subtotal]'));

	subTotalElements.forEach(elem => {
		let id = Number(elem.dataset.subtotal);
		let lineItem = getLineItemById(cart.lineItems, id);

		elem.textContent = formatCurrency(lineItem.subtotal);
	});
}

function getLineItemById(items, id) {
	return items.find(item => item.id === id);
}
